export default __webpack_public_path__ + "static/media/a21.54d3b8fa.webp";